import { useTranslation } from "@flare/i18n";
import { Icon, Text } from "@flare/ui";

export function ConfirmationNextSteps() {
  const { t } = useTranslation();

  const items = [
    t("FUNNEL_STEP_INTAKE_CONFIRMATION_DESCRIPTION_ONE"),
    t("FUNNEL_STEP_INTAKE_CONFIRMATION_DESCRIPTION_TWO"),
    t("FUNNEL_STEP_INTAKE_CONFIRMATION_DESCRIPTION_THREE"),
  ];

  return (
    <div className="items-between mb-sp-3 mt-sp-8 flex w-full max-w-screen-lg flex-col items-start gap-sp-6 md:mb-sp-6 md:mt-[56px] md:flex-row md:items-center">
      {items.map((text) => (
        <div key={text} className="flex items-center gap-sp-4 md:flex-row">
          <div className="flex size-[40px] shrink-0 items-center justify-center rounded-full bg-success">
            <Icon name="check" size="sm" color="action" />
          </div>
          <Text variant="body2">{text}</Text>
        </div>
      ))}
    </div>
  );
}
